import type { WeeklyConfig, WeeklyDetail, WeeklyNotes, WeeklyWeekSummary } from '@dxtech/shared';
import { call } from './library.js';

// 주간보고 API
export interface WeeklyPerson { upn: string; name: string; dept: string; title?: string; }

export const weeklyApi = {
  list: async (year?: string) => (await (await call(`/weekly${year ? `?year=${year}` : ''}`)).json()) as {
    weeks: WeeklyWeekSummary[]; next: string; year: string; years: string[]; total: number; receivers: string[];
  },
  week: async (key: string) => (await (await call(`/weekly/week?key=${key}`)).json()) as WeeklyDetail,
  // upn 지정 = 관리자가 다른 보고자 칸 수정
  save: async (key: string, done: string, plan: string, upn?: string) =>
    (await (await call('/weekly/week', { key, done, plan, upn })).json()) as { updatedAt: string },
  config: async () => (await (await call('/weekly/config')).json()) as { config: WeeklyConfig; employees: WeeklyPerson[] },
  saveConfig: (order: string[], excluded: string[], receivers: string[]) => call('/weekly/config', { order, excluded, receivers }),
  // 피보고자 메모 — baseUpdatedAt 으로 동시 수정 충돌 감지(409)
  saveNotes: (key: string, sections: WeeklyNotes['sections'], baseUpdatedAt?: string) => call('/weekly/notes', { key, sections, baseUpdatedAt }),
  setMeeting: (key: string, at: string | null) => call('/weekly/meeting', { key, at }),
  // 첨부 — target: entry(보고자 칸 done|plan, upn 지정 = 관리자) / notes(피보고자 메모 work|notice|ref)
  uploadFile: async (key: string, target: 'entry' | 'notes', section: string, file: File, upn?: string) => {
    const contentBase64 = await new Promise<string>((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => resolve(String(fr.result).split(',')[1] ?? '');
      fr.onerror = () => reject(new Error('파일 읽기 실패'));
      fr.readAsDataURL(file);
    });
    return call('/weekly/file', { key, target, section, upn, fileName: file.name, contentBase64, contentType: file.type || 'application/octet-stream' });
  },
  removeFile: (key: string, target: 'entry' | 'notes', id: string, upn?: string) => call('/weekly/file/delete', { key, target, id, upn }),
  downloadFile: async (id: string, name: string): Promise<void> => {
    const blob = await (await call(`/weekly/file?id=${encodeURIComponent(id)}`)).blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};
